<template>
    <div class="trade-page-tabs">
        <!-- Tab Navigation -->
        <div class="analytics-tabs mb-4">
            <button class="tab-btn" :class="{ active: activeTab === 'swap' }" @click="setTab('swap')">
                <i class="fas fa-exchange-alt me-1"></i> Swap
            </button>
            <button class="tab-btn" :class="{ active: activeTab === 'dca' }" @click="setTab('dca')">
                <i class="fas fa-redo me-1"></i> DCA
            </button>
            <button class="tab-btn" :class="{ active: activeTab === 'limits' }" @click="setTab('limits')">
                <i class="fas fa-crosshairs me-1"></i> Limit Orders
            </button>
        </div>

        <!-- Swap Tab -->
        <div v-show="activeTab === 'swap'" class="trade-tab-content">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-8">
                    <swap-widget
                        :input-token="fromMint"
                        :output-token="toMint"
                    ></swap-widget>
                </div>
                <div class="col-lg-5 col-md-8 mt-4 mt-lg-0">
                    <open-orders></open-orders>
                </div>
            </div>
        </div>

        <!-- DCA Tab -->
        <div v-show="activeTab === 'dca'" class="trade-tab-content">
            <div class="row">
                <div class="col-lg-5 col-md-8">
                    <dca-orders></dca-orders>
                </div>
                <div class="col-lg-7">
                    <dca-order-list class="mt-4 mt-lg-0"></dca-order-list>
                </div>
            </div>
        </div>

        <!-- Limit Orders Tab -->
        <div v-show="activeTab === 'limits'" class="trade-tab-content">
            <div class="row">
                <div class="col-lg-5 col-md-8">
                    <limit-orders></limit-orders>
                </div>
                <div class="col-lg-7">
                    <limit-order-list class="mt-4 mt-lg-0"></limit-order-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TradePage',

    props: {
        initialTab: {
            type: String,
            default: 'swap',
        },
    },

    data() {
        return {
            activeTab: this.initialTab,
        };
    },

    computed: {
        fromMint() {
            const params = new URLSearchParams(window.location.search);
            return params.get('from') || 'So11111111111111111111111111111111111111112';
        },
        toMint() {
            const params = new URLSearchParams(window.location.search);
            return params.get('to') || '';
        },
    },

    methods: {
        setTab(tab) {
            this.activeTab = tab;
            const url = new URL(window.location);
            url.searchParams.set('tab', tab);
            window.history.replaceState({}, '', url);
        },
    },
};
</script>
